import { render, staticRenderFns } from "./IFrameField.vue?vue&type=template&id=6d1ede30"
import script from "./IFrameField.vue?vue&type=script&lang=js"
export * from "./IFrameField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports